// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist-view-state-content {
  background-color: #ffffff;
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/checkpoint-answer-view-state/checkpoint-answer-view-state.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;AACJ","sourcesContent":[".fi-checklist-view-state-content {\r\n    background-color: #ffffff;\r\n    padding: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
